import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { AccreditationSolutionConfig } from '../../../_types/accreditation';

export async function getAccreditationSolutionConfig(signal?: AbortSignal): Promise<AccreditationSolutionConfig> {
  const url = `${baseApiUrl()}/admin-solution/v1/solutions/awb/config`;

  try {
    const response = await fetcher({
      method: 'GET',
      url,
      options: { signal },
    });
    return response;
  } catch (error: unknown) {
    if (typeof error === 'object' && error !== null && 'errorDetails' in error) {
      throw error as ServerErrorResponse;
    }
    throw error;
  }
}

export default function useAccreditationSolutionConfig(
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  return useQuery<AccreditationSolutionConfig, ServerErrorResponse>(
    ['accreditationSolutionConfig'],
    async ({ signal }): Promise<AccreditationSolutionConfig> => {
      try {
        return await getAccreditationSolutionConfig(signal);
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      staleTime: 5 * 60 * 1000, // 5 minutes
      ...options,
      keepPreviousData: true,
    }
  );
}
